import React, { useState, useEffect } from "react";
import Contact from "../components/Contact";
import { useLocation } from "react-router-dom";

const ContactPages = () => {
  const [sıkSorulanlarIndex, setSıkSorulanlarIndex] = useState(null);
  const sıkSorulanlarToggle = (index) => {
    if (sıkSorulanlarIndex === index) {
      setSıkSorulanlarIndex(null);
    } else {
      setSıkSorulanlarIndex(index);
    }
  };

  const { hash } = useLocation();
  useEffect(() => {
      if (hash) {
        const targetId = hash.replace("#", "");
  
        const timer = setTimeout(() => {
          const element = document.getElementById(targetId);
          if (element) {
            // Elementin sayfa üzerindeki konumunu buluyoruz
            const targetPosition =
              element.getBoundingClientRect().top + window.pageYOffset;
            const startPosition = window.pageYOffset;
            const distance = targetPosition - startPosition;
            const duration = 2000;
            let start = null;
  
            const step = (timestamp) => {
              if (!start) start = timestamp;
              const progress = timestamp - start;
  
              const easeInOutQuad = (t) =>
                t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
              const scrollY =
                startPosition +
                distance * easeInOutQuad(Math.min(progress / duration, 1));
  
              window.scrollTo(0, scrollY);
  
              if (progress < duration) {
                window.requestAnimationFrame(step);
              }
            };
  
            window.requestAnimationFrame(step);
          }
        }, 300);
  
        return () => clearTimeout(timer);
      }
    }, [hash]);

  const sıkSorulanlarData = [
    {
      title: "Seanslar ne kadar sürüyor?",
      items: [
        "Bireysel terapi seansları yaklaşık 50 dakika sürmektedir. Grup terapileri ise içeriğe ve yapılandırmaya göre 90–120 dakika arasında değişebilir. Seans sıklığı genel olarak haftada bir düzenlenir; ancak sürecin ihtiyaçları doğrultusunda daha sık ya da daha seyrek planlanabilir. Terapi ilerledikçe ve danışanın ihtiyaçları değiştikçe seans aralıkları iki haftada bir ya da ayda bir olacak şekilde yeniden düzenlenebilir. Bu planlama, terapi hedefleriniz ve ilerleyişiniz doğrultusunda birlikte yapılır.",
      ],
    },
    {
      title: "Terapist Seçerken Nelere Dikkat Etmeliyim?",
      items: [
        "Terapist seçerken, terapistin eğitim geçmişi, uzmanlık alanları ve çalıştığı terapi yaklaşımları hakkında bilgi edinmek önemlidir. Sizin için uygun yaklaşım; yaşadığınız zorlukların türüne, beklentilerinize ve ihtiyaçlarınıza göre değişebilir. Ayrıca, terapistle kurduğunuz güven ve iletişim hissi de terapi sürecinin en belirleyici unsurlarından biridir.",
      ],
    },
    {
      title: "Online Terapi Yüz Yüze Terapi Kadar Etkili midir?",
      items: [
        "Yapılan çalışmalar, güvenli ve gizli bir ortamda yapıldığında online terapinin yüz yüze terapi kadar etkili olabileceğini göstermektedir. Özellikle ulaşım zorluğu olanlar ve farklı şehirlerde yaşayanlar için çevrimiçi seanslar iyi bir alternatiftir.",
      ],
    },

    {
      title: "Terapiden Ne Zaman Fayda Görmeye Başlarım?",
      items: [
        "Terapinin yararlı olup olmadığını anlamak için hedeflediğiniz sorunlar üzerinde ilerleme kaydedip kaydetmediğinize bakabilirsiniz. Kendinizi daha iyi hissettiğinizde, çevrenizden olumlu geri bildirimler aldığınızda ve belirlediğiniz hedeflere doğru ilerlediğinizi fark ettiğinizde terapinin faydasını görmeye başlarsınız.",
      ],
    },
    {
      title: "Psikolog ve Psikiyatrist Arasındaki Fark Nedir?",
      items: [
        "Psikologlar psikoterapi uygulayarak duygusal ve davranışsal sorunlar üzerine çalışır; ilaç yazma yetkisi yoktur. Psikiyatristler tıp eğitimi almış hekimlerdir, tanı koyma ve ilaç tedavisi uygulama yetkisine sahiptir. Tedavi gereksinimine göre psikolog ve psikiyatrist beraber de çalışabilir.",
      ],
    },
    {
      title:
        "Seans iptalleri durumunda nasıl bir ücret politikası uygulanıyor?",
      items: [
        "Terapi sürecinde düzenliliğin korunması, iyileşme yolculuğunun önemli bir parçasıdır. Bu nedenle seans iptalleriyle ilgili belirli bir çerçeve bulunmaktadır.",
        "Bildirim süresi: Seansınızı iptal etmek istediğinizde en az 24 saat önceden haber vermeniz gerekir. Bu süre içinde yapılan iptallerde herhangi bir ücret talep edilmez.",
        "Geç iptaller ve gelinmeyen seanslar: 24 saatten daha kısa sürede yapılan iptallerde veya seansa katılınmadığında, seans ücreti tahsil edilmektedir.",
        "İstisnalar: Beklenmedik sağlık sorunları veya acil durumlar gibi istisnai koşullar olduğunda, bu durum birlikte değerlendirilebilir.",
        "Bu uygulamanın amacı yalnızca terapistin zamanını korumak değil; aynı zamanda terapi çerçevesinin bir parçası olarak sınırların ve sorumluluğun netleşmesini sağlamaktır. Düzenlilik, sürece bağlılık ve kendi iyileşme yolculuğunuza yatırım yapma bilinci; terapötik değişimi destekleyen temel unsurlardandır.",
      ],
    },
    {
      title: "Grup terapisi ve atölye arasındaki fark nedir?",
      items: [
        "Grup terapisi, genellikle 8–12 hafta süren düzenli seanslardan oluşur ve terapi odaklıdır. Yani kişinin içsel şemaları, duyguları ve düşünce kalıpları üzerine daha derin çalışılır. Katılımcılar terapötik bir süreç içinde değişim ve iyileşme hedefler. Terapist, süreci yapılandırır ve şemalar/modlarla deneyimsel çalışmalar yapılır. Kapalı bir gruptur; üyeler birbirini tanır, süreç birlikte ilerler.",
        "Atölyeler (workshop) ise kısa süreli ve daha çok psikoeğitim odaklı çalışmalardır. Katılımcılar belirli bir tema üzerine (öz şefkat, mindfulness, sınırlar, duyguları tanıma gibi) pratik bilgiler ve egzersizler öğrenir. Terapi sürecinden ziyade, kişisel gelişim ve farkındalık ağırlıklıdır. Daha açık formatlı olabilir; katılım bir defalık da mümkündür.",
      ],
    },
  ];

  return (
    <>

      {/* Sık Sorulanlar */}
      <div
        id="faqs"
        className="row"
        style={{ backgroundColor: /*"rgb(239, 235, 225)"*/ "white", padding: "60px 0" }}
      >
        <div className="col-md-6 faq-title-container d-flex justify-content-center">
          <h1
            className="text-center p-5"
            style={{ fontSize: "clamp(36px, 5vw, 44px)" }}
          >
            Sık Sorulanlar
          </h1>
        </div>

        <div
          className="d-flex col-md-6 p-5"
          style={{ backgroundColor: "white" }}
        >
          <div style={{ width: "90%", maxWidth: "600px" }}>
            {sıkSorulanlarData.map((section, index) => (
              <div
                key={index}
                style={{
                  borderBottom: "1px solid black",
                  padding: "0.5rem 0.4rem",
                  color: "black",
                }}
              >
                {/* Ana Başlık */}
                <div
                  onClick={() => sıkSorulanlarToggle(index)}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>{section.title}</span>
                  <span style={{ fontSize: "20px", fontWeight: "bold" }}>
                    {sıkSorulanlarIndex === index ? "−" : "+"}
                  </span>
                </div>

                {/* Alt Maddeler */}
                {sıkSorulanlarIndex === index && (
                  <ul
                    style={{
                      marginTop: "0.5rem",
                      marginBottom: 0,
                      paddingLeft: "1.5rem",
                    }}
                  >
                    {section.items.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

        <Contact />
    </>
  );
};

export default ContactPages;
